import type { SymptomId } from "@ferrivia/api-contract";
import { useTranslation } from "@ferrivia/i18n";

export function useSymptomLabels(): Record<SymptomId, string> {
  const { t } = useTranslation("client");
  // One literal t() call per id — i18next-parser only extracts static keys,
  // so a templated `symptomCheckin.symptoms.${id}` key would never make it
  // into the catalog. The Record<SymptomId, ...> annotation forces this list
  // to be updated whenever a symptom is added or removed from the contract.
  return {
    fatigue: t("symptomCheckin.symptoms.fatigue", "Väsymys"),
    weakness: t("symptomCheckin.symptoms.weakness", "Heikotus"),
    feeling_cold: t("symptomCheckin.symptoms.feeling_cold", "Palelu"),
    cold_hands_feet: t("symptomCheckin.symptoms.cold_hands_feet", "Kylmät kädet ja jalat"),
    brain_fog: t("symptomCheckin.symptoms.brain_fog", "Aivosumu"),
    poor_concentration: t("symptomCheckin.symptoms.poor_concentration", "Keskittymisvaikeudet"),
    mood_swings: t("symptomCheckin.symptoms.mood_swings", "Mielialavaihtelut"),
    irritability: t("symptomCheckin.symptoms.irritability", "Ärtyneisyys"),
    headache: t("symptomCheckin.symptoms.headache", "Päänsärky"),
    dizziness: t("symptomCheckin.symptoms.dizziness", "Huimaus"),
    hair_loss: t("symptomCheckin.symptoms.hair_loss", "Hiustenlähtö"),
    brittle_nails: t("symptomCheckin.symptoms.brittle_nails", "Hauraat kynnet"),
    pallor: t("symptomCheckin.symptoms.pallor", "Kalpeus"),
    sore_mouth: t("symptomCheckin.symptoms.sore_mouth", "Kipeä tai arka suu"),
    chest_pain: t("symptomCheckin.symptoms.chest_pain", "Rintakipu"),
    palpitations: t("symptomCheckin.symptoms.palpitations", "Sydämentykytys"),
    breathlessness: t("symptomCheckin.symptoms.breathlessness", "Hengästyminen"),
    poor_exercise_recovery: t("symptomCheckin.symptoms.poor_exercise_recovery", "Huono palautuminen liikunnasta"),
    muscle_cramps: t("symptomCheckin.symptoms.muscle_cramps", "Lihaskrampit"),
    low_immunity: t("symptomCheckin.symptoms.low_immunity", "Alhainen vastustuskyky"),
    insomnia: t("symptomCheckin.symptoms.insomnia", "Unettomuus"),
    restless_legs: t("symptomCheckin.symptoms.restless_legs", "Levottomat jalat"),
  };
}
